import React from 'react'
import { string } from 'prop-types'

const Element = ({ as, ...other }) => {
  const ElementEl = as

  return <ElementEl {...other} />
}

Element.defaultProps = {
  as: 'div'
}

Element.propTypes = {
  as: string
}

export default Element
